// Row template for `add-font-family-modal.js`'s font-stack ordering list —
// moved out of the page module and registered here (2026-08-14, bare-string
// extends registration sweep) because a bare-string `childExtends:
// 'OrderingItem'` resolves ONLY against the live `context.components`
// registry (smbls's `resolveExtend`, smbls/packages/element/src/extends.js),
// never against a sibling key or a page-local declaration. Defining it
// inline in the page (as a sibling of the `Tools` node that childExtends it)
// left it permanently unresolvable — same defect class as the AdminLedgerRow
// bug (workspace eb5a41bd): every ordering row silently mounted as a bare
// unstyled div.
export const OrderingItem = {
  Buttons: null,
  Span: {
    text: (el, s) => `${parseInt(s.parent.value?.length + 1)}. `
  },
  Tool: {
    width: '22em',
    maxWidth: '22em',
    Value: {
      color: 'white.5',
      Text: {
        text: 'Helvetica, Arial, sans-serif, --system-default'
      }
    },
    Buttons: {
      children: [
        {
          theme: 'transparent'
        }
      ],
      childrenAs: 'props'
    }
  }
}
